import React, { useEffect, useState } from "react";
import { Table, Button, Row, Col, App,  Tooltip, Drawer, Grid } from "antd";
import { DeleteOutlined, EditOutlined, PlusOutlined, QuestionCircleOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchRacksList, deleteRack } from "../racksThunks";
import { selectRacksList } from "../racksSelectors";
import { setSelectedRack, setIsEditRack } from "../racksSlice";
import { useIsAdminUser } from "../../../lib/accessList";

const RacksList = () => {
  const { modal } = App.useApp();
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isAdminUser = useIsAdminUser();
  const authInfo = useSelector((state) => state.auth?.auth_info);

  const canEdit = authInfo?.can_edit === 1;
  const canDelete = authInfo?.can_delete === 1;

  const racksList = useSelector(selectRacksList);
  const [helpOpen, setHelpOpen] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
  });


  const handleTableChange = (pagination) => {
    setPagination(pagination);
  };
  const handleDelete = (id, rack_name) => {
    modal.confirm({
      title: "Are you sure?",
      content: `This will delete rack: ${rack_name}`,
      okText: "Yes, Delete",
      cancelText: "Cancel",
      onOk: async () => {
        try {
          await dispatch(deleteRack(id)).unwrap();
          modal.success({ title: "Rack deleted successfully" });
          dispatch(fetchRacksList());
        } catch (err) {
          modal.error({ title: err.message || "Delete failed" });
        }
      },
    });
  };

  const columns = [
    { title: "No.", render: (_, __, index) => index + 1 },
    { title: "Rack Name", dataIndex: "name" },
    {
      title: "Actions",
      render: (_, record) => (
        <>
          <Button
            type="link"
            disabled={!(isAdminUser || canEdit)}
            onClick={() => {
              dispatch(setSelectedRack(record));
              dispatch(setIsEditRack(true));
              navigate("/inventory/racks-manage/addNewRack");
            }}
            icon={<EditOutlined />}
          />
          <Button
            type="link"
            disabled={!(isAdminUser || canDelete)}
            danger
            onClick={() => {
              handleDelete(record.id, record.name);
            }}
            icon={<DeleteOutlined />}
          />
        </>
      ),
    },
  ];

  useEffect(() => {
    dispatch(setSelectedRack(null));
    dispatch(setIsEditRack(false));
    dispatch(fetchRacksList());
  }, [dispatch]);

  return (
    <>
      {/* <Row justify="end" style={{ marginBottom: "32px", marginTop: "32px" }}> */}
      <Row
  justify="end"
  align="middle"
  gutter={12}
  style={{ marginBottom: "32px", marginTop: "32px" }}
>
        <Col>
          <Tooltip title="Help">
            <Button
              type="text"
              icon={<QuestionCircleOutlined style={{ fontSize: 18 }} />}
              onClick={() => setHelpOpen(true)}
            />
          </Tooltip>
        </Col>
        <Col>
          <Button
            type="primary"
            className="traic-button"
            icon={<PlusOutlined />}
            onClick={() => {
              dispatch(setSelectedRack(null));
              dispatch(setIsEditRack(false));
              navigate("addNewRack");
            }}
          >
            Add New
          </Button>
        </Col>
      </Row>
      <Table
        columns={columns}
        dataSource={racksList}
        rowKey="rack_id"
        pagination={{
          ...pagination,
          showSizeChanger: true,
          pageSizeOptions: ["10", "20", "50"],
        }}
        onChange={handleTableChange}
        scroll={{ x: "max-content" }}
      />
      <Drawer
        title="Rack Management Help"
        open={helpOpen}
        onClose={() => setHelpOpen(false)}
        width={420}
        styles={{
          wrapper: {
            paddingTop: !screens.md ? "80px" : undefined
          }
        }}
      >
        <div style={{ lineHeight: 1.8 }}>
          <h2
            style={{
              fontSize: "18px",
              fontWeight: 600,
              marginBottom: "12px",
              marginLeft: "8px",
            }}
          >
            Rack Management
          </h2>

          <p
            style={{
              color: "#555",
              marginBottom: "16px",
              marginLeft: "8px",
            }}
          >
            The Rack Management module is used to create and manage storage
            racks within the ERP inventory system. Racks help organize warehouse
            storage locations for easier stock handling, tracking, and inventory management.
          </p>

          <div
            style={{
              background: "#f5f5f5",
              padding: "14px",
              borderRadius: "8px",
              marginBottom: "16px",
            }}
          >
            <strong>Available Actions</strong>

            <ol style={{ paddingLeft: "20px", marginTop: "10px" }}>
              <li>View existing rack records</li>
              <li>Use <strong>Add New</strong> to create rack entries</li>
              <li>Edit rack details when required</li>
              <li>Delete unused rack entries if permitted</li>
              <li>Manage warehouse storage locations</li>
              <li>Organize inventory stock placement efficiently</li>
            </ol>
          </div>

          <div
            style={{
              background: "#fafafa",
              border: "1px solid #eee",
              padding: "14px",
              borderRadius: "8px",
            }}
          >
            <strong>Important Notes</strong>

            <ul
              style={{
                paddingLeft: "18px",
                marginTop: "10px",
                color: "#666",
              }}
            >
              <li>Rack names should remain unique for better organization.</li>
              <li>Deleting rack entries may affect warehouse stock mapping.</li>
              <li>Access permissions control edit and delete actions.</li>
              <li>Rack management improves inventory storage tracking.</li>
            </ul>
          </div>
        </div>
      </Drawer>
    </>
  );
};

export default RacksList;
